import * as React from 'react'
import styled from 'styled-components'
import { CartItem } from 'hooks/account/types'
import B2cSwitch from 'theme/atoms/B2cSwitch'
import theme from 'theme'

type Props = {
  item: CartItem
}

export default function ReferencePrice(props: Props) {
  if (!props.item.prices.referencePriceNetString) return null

  return (
    <Wrapper className="ReferencePrice" data-cy-state="has-reference-price">
      <B2cSwitch.B2B>{props.item.prices.referencePriceNetString}</B2cSwitch.B2B>
      <B2cSwitch.B2C>
        {props.item.prices.referencePriceGrossString}
      </B2cSwitch.B2C>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  ${theme.ty('r-xs', null, 'r-s')}
  color: ${theme.colors.shade.b2};
`
